<template>
  <div class="maintenance__wrap">
    <div class="maintenance__header"></div>
    <div class="maintenance__content-wrap">
      <h1 class="maintenance__title">
        <Crane class="maintenance__logo" />Motion Mail
      </h1>
      <div class="maintenance__content-wrap-floating">
        <p
          class="text-size-md weight--heavier layout--margin-bottom-xs layout--margin-top-sm"
        >
          Sorry, we are currently down for maintenance.
        </p>
        <p class="maintenance__content weight--light layout--margin-bottom-md">
          We are performing some improvements to our service. We will be back
          online shortly. For updates, check our twitter.
        </p>
        <a
          href="https://twitter.com/MotionMailApp"
          class="maintenance__link"
          target="_blank"
          ><Twitter class="layout--margin-right-xs" />@MotionMailApp</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Crane from "../assets/images/motionmail-maintenance-crane.svg";
import Twitter from "../assets/images/icon-twitter.svg";

export default {
  name: "maintenance",
  components: {
    Crane,
    Twitter,
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/pages/_maintenance.scss";
</style>
